export namespace GameAnimationData {
    export const backgroundAnimationName: string = "backgroundAnimation";
    export const pathToBackgroundAnimationAssets: string = "game-animation/background.json"
    export const foregroundAnimationName: string = "foregroundAnimation";
    export const pathToForegroundAnimationAssets: string = "game-animation/foreground.json"
    export const crocoAnimationName: string = "crocAnimation";
    export const pathToCrocoAnimationAssets: string = "game-animation/croco.json";
    export const signAnimationName: string = "signAnimation";
    export const pathToSignAnimationAssets: string = "game-animation/multiplier_sign.json";
    export const glowAnimationName: string = "glowAnimation";
    export const pathToGlowAnimationAssets: string = "game-animation/screen_glow.json";
}
